var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinkBack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.09047 14.5837C6.70839 14.5837 6.32776 14.4349 6.04193 14.1389L0.408391 8.30557C-0.142859 7.73245 -0.135567 6.82391 0.42735 6.26099L6.26068 0.427656C6.82943 -0.142552 7.75256 -0.142552 8.32276 0.427656C8.89151 0.997865 8.89151 1.91953 8.32276 2.48974L3.50297 7.30953L8.13902 12.1118C8.69901 12.6922 8.68297 13.6154 8.10401 14.1739C7.81964 14.4481 7.45506 14.5837 7.09047 14.5837Z",
    fill: "#E40587"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkBack);
export default __webpack_public_path__ + "static/media/pink-back.6d4321914e260fcf324b6426360f298f.svg";
export { ForwardRef as ReactComponent };